import { PORTFOLIOS } from "../../constants";

// FILTER FIELDS
const NPL_ANTICIPA_FILTER_FIELDS_METADATA = [
  {
    type: "text",
    id: "nplId",
    placeholder: "Código NPL",
    autoComplete: "off",
    maxLength: 20,
  },
  {
    type: "text",
    id: "code",
    placeholder: "Código de Producto",
    autoComplete: "off",
    maxLength: 20,
  },
  {
    type: "text",
    id: "dossierCode",
    placeholder: "Expediente",
    autoComplete: "off",
    maxLength: 20,
  },
  {
    type: "number",
    id: "prinexId",
    placeholder: "Id Prínex",
    autoComplete: "off",
    maxLength: 10,
  },
  {
    type: "list",
    id: "assetType",
    defaultOption: "Tipo de Activo",
    listName: "assetType",
    value: "Id",
    label: "translation",
  },
  {
    type: "customList",
    id: "isPublishable",
    defaultOption: "Publicado: Todos",
    customValues: [true, false],
    customLabels: ["Publicado", "No Publicado"],
  },
  {
    type: "list",
    id: "provinceId",
    defaultOption: "Provincia",
    listName: "appProvinces",
    value: "id",
    label: "name",
  },
  {
    type: "dependentList",
    id: "municipalityId",
    defaultOption: "Municipio",
    listName: "appMunicipalities",
    parentListId: "provinceId",
    value: "id",
    label: "name",
  },
  {
    type: "text",
    id: "propertyCode",
    placeholder: "Inmueble",
    autoComplete: "off",
    maxLength: 50,
  },
];

const NPL_QUASAR_FILTER_FIELDS_METADATA = [
  ...NPL_ANTICIPA_FILTER_FIELDS_METADATA,
];

const NPL_SAREB_FILTER_FIELDS_METADATA = [
  ...NPL_ANTICIPA_FILTER_FIELDS_METADATA,
];

const NPL_TERCEROS_FILTER_FIELDS_METADATA = [
  ...NPL_ANTICIPA_FILTER_FIELDS_METADATA,
];

const { NPL_ANTICIPA, NPL_QUASAR, NPL_SAREB, NPL_TERCEROS } = PORTFOLIOS;
export const FILTER_FIELDS_METADATA = {
  [NPL_ANTICIPA]: NPL_ANTICIPA_FILTER_FIELDS_METADATA,
  [NPL_QUASAR]: NPL_QUASAR_FILTER_FIELDS_METADATA,
  [NPL_SAREB]: NPL_SAREB_FILTER_FIELDS_METADATA,
  [NPL_TERCEROS]: NPL_TERCEROS_FILTER_FIELDS_METADATA,
};

// RESULT TABLE COLUMNS
export const ALL_COLUMNS_METADATA = [
  {
    label: "",
    id: "empty",
    disableSortBy: true,
  },
  {
    label: "",
    id: "checkValidate",
    disableSortBy: true,
  },
  {
    label: "",
    id: "detail",
    disableSortBy: true,
  },
  {
    label: "Código Producto",
    id: "code",
  },
  {
    label: "Id Prínex",
    id: "prinexId",
    disableSortBy: true,
  },
  {
    label: "Id Promoción Prinex",
    id: "promotionCode",
    disableSortBy: true,
  },
  {
    label: "Nombre",
    id: "name",
    disableSortBy: true,
  },
  {
    label: "Expediente",
    id: "dossierCode",
    disableSortBy: true,
  },
  {
    label: "Estado Comercial",
    id: "commercialStatus",
    disableSortBy: true,
  },
  {
    label: "L. de Negocio",
    id: "businessLine",
    disableSortBy: true,
  },
  {
    label: "Tipo",
    id: "assetType",
    disableSortBy: true,
  },
  {
    label: "Descripción",
    id: "description",
    disableSortBy: true,
  },
];

// export const NPL_COLUMNS_METADATA = ALL_COLUMNS_METADATA;
export const NPL_COLUMNS_METADATA = [
  ...ALL_COLUMNS_METADATA.slice(0, 3),
  {
    label: "NPL Id",
    id: "nplId",
    disableSortBy: true,
  },
  ...ALL_COLUMNS_METADATA.slice(3).filter(
    (e) => e.id !== "promotionCode" && e.id !== "businessLine"
  ),
];
